import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const startBatchGenerateCompetitorAliases = unaryRpc({
  name: "startBatchGenerateCompetitorAliases",
  input: z.object({ teamIds: z.array(z.string()).optional() }),
  output: z.object({
    workflowId: z.string(),
    status: z.literal("started"),
    teamsQueued: z.number(),
    teamsSkipped: z.number(),
  }),
});
